
$(document).ready(function() {
  let availableSubscriptionFrequencies;
  var subscriptionPrice
  var originalPrice
  var isExperimentalRechargeVisible

  // function to wait the necessary element to present on the page. In case of this script - waiting for ReCharge plugin to initialize
  function waitForElement(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  } 

  function onVariantChange(value) {
    if (productVariants[value].metafields.allow_subscription !== undefined) {
      changePurchaseType(productVariants[value].metafields.allow_subscription);
    } else if (productVariants[value].metafields.deny_subscription_for_customer_tags !== undefined) {
      let denyCustomerTags = productVariants[value].metafields.deny_subscription_for_customer_tags;
      const userTags = [];
      if (customerTags) {
        customerTags.forEach(element => {
          userTags.push(element.toLowerCase());
        });
      }
      let isDenied = denyCustomerTags.some(x => userTags.indexOf(x.toLowerCase()) !== -1);
      changePurchaseType(!isDenied);
    }
    else {
      changePurchaseType(true);
    }

    if (productVariants[value].metafields.allowed_frequencies !== undefined) {
      changeOptions(productVariants[value]);
      if (productVariants[value].metafields.experimental_selector && !isExperimentalRechargeVisible) {
        isExperimentalRechargeVisible = true;
      }
    } else {
      displayAllVariantsSelect()
    }
  }

  /**
   * Function that is responsible for adding ids, so we can further change the RC widget to match the new experiment
   */
  function modifyRcMarkup() {
    // General CSS Changes
    $(".rc-radio").css({ "font-weight": "bold", "padding-left": "32px"})
    $('.subscription-radio').css('padding-top', '13px')
    $(".rc-radio__label").css({'margin-left': '13px', "line-height": "normal", "text-transform": "uppercase", "font-size": '18px', "font-weight": '700px'})
    $(".rc-widget").css('border', '0.5px solid #b1b1b1')
    $(".rc-radio__input").css('accent-color', '#F85E11').removeClass('mr-3')
    $("#subscription-options").css('padding-bottom', '21px')


    // Subscription Block modifications
    $(".rc-selling-plans").attr('id', 'subscription-options')
    $(".subscription-radio").attr('id', 'subscription-content')
    // $('.otp-purchase-price').css( )

    // One time purchase block modifications
    $(".onetime-radio").attr('id', 'onetime-purchase')

    // Remove subscription details completely
    $(".rc-subscription-details").remove();

    // Subscription Radio CSS changes
    // $(".rc-selling-plans").css("padding-left", '18px');
    $(".rc-selling-plans").css({"padding-left": '32px', 'padding-right': '32px'});
    
    //One time purchase CSS changes
    $('.onetime-radio').css({'border-top': '0.5px solid #b1b1b1', "padding-top": "27px", "padding-bottom": "18px"})

    modifySubscriptionMarkup()
  }

  
  function createSubscriptionBulletPoint(content) {
    // Create a new <div> element for the bullet point
    var newBulletPoint = document.createElement('div');
    newBulletPoint.className = 'subscription-perk';
  
    // Create an <img> element for the orange checkmark icon
    var orangeCheckmarkIcon = document.createElement('img');
    orangeCheckmarkIcon.src = orangeCheckmarkUrl;
  
    // Append the orangeCheckmarkIcon to the newBulletPoint
    newBulletPoint.appendChild(orangeCheckmarkIcon);
  
    // Create a temporary container for the content and parse it as HTML
    var contentContainer = document.createElement('div');
    contentContainer.innerHTML = content;
  
    // Copy the child nodes (including the class names) to the newBulletPoint
    while (contentContainer.firstChild) {
      newBulletPoint.appendChild(contentContainer.firstChild);
    }
  
    return newBulletPoint;
  }

  function modifySubscriptionMarkup() {
    // Get the original text content
    var oneTimePurchaseSelector = $('#onetime-purchase').children('.rc-radio__label').text().trim()
    var originalText = $(".rc-radio__label").text().trim();

    // Extract the price from the original text
    if (originalText) {
      subscriptionPrice = originalText.match(/([$€])\s?(\d+(?:[.,]\d{1,2})?)/)[0];
    }

    if (oneTimePurchaseSelector) {
      originalPrice = oneTimePurchaseSelector.match(/(?:€|\$)(\d+(?:[.,]\d{1,2})?)/)[0];
    }
    
    // Remove the price from the original text
    var label = '\n (Regular Price = ' + originalPrice + ')'

    // Create the new content with the desired format
    var newContent = '<div class="subscription-price-container"><span class="regular-price">SUBSCRIPTION | ' + subscriptionPrice + '</span><span class="otp-purchase-price">' + label + '</span></div>' + '</div>';
    
    var firstBullet = createSubscriptionBulletPoint('<p class="subscription-bullet-content">Save up to <span class="orange-highlight">20%</span> on the products you love</p>')
    var secondBullet = createSubscriptionBulletPoint('<p class="subscription-bullet-content">Score <span class="orange-highlight">free shipping</span> on subscription order, every time</p>')
    var thirdBullet = createSubscriptionBulletPoint('<p class="subscription-bullet-content">Claim a complimentary luxe <span class="orange-highlight">massaging scalp brush</span></p>')
    var fourthBullet = createSubscriptionBulletPoint('<p class="subscription-bullet-content">Enjoy a <span class="orange-highlight">free bottle & pump</span> for larger sizes</p>')
    var fifthBullet = createSubscriptionBulletPoint('<p class="subscription-bullet-content">Keep hair healthy & get <span class="orange-highlight">iconic style instantly</span></p>')
    var sixthBullet = createSubscriptionBulletPoint('<p class="subscription-bullet-content">Cancel, pause or switch it up whenever you want</p>')
    

    // Replace the content of the element with the new content
    var subscriptionPerkContainer = '<div class="subscription-highlights"></div>'

    $('.rc-selling-plans').append(subscriptionPerkContainer)
    $(".subscription-highlights").append(firstBullet)
    $(".subscription-highlights").append(secondBullet)
    $(".subscription-highlights").append(thirdBullet)
    $(".subscription-highlights").append(fourthBullet)
    $(".subscription-highlights").append(fifthBullet)
    $(".subscription-highlights").append(sixthBullet)
    
    
    
    $('.subscription-highlights').css('padding-bottom', '16px')
    $("#subscription-content").children('.rc-radio__label').html(newContent);
    $('.subscription-price-container').css({'display': 'flex', 'flex-direction': 'column'})
    $('.otp-purchase-price').css({'font-size': '14px', 'color': "#989898", 'text-transform': 'none'})
    $('.subscription-perk').css({'display': 'flex', 'align-items': 'baseline'})
    $('.subscription-bullet-content').css({'line-height': 'normal', 'margin-left': '14px'})
    $('.crossed-out').css('text-decoration', 'line-through')
    $('.orange-highlight').css({color: '#F85E11', 'font-weight': "bold"})
    $('#onetime-purchase').css({display: 'flex', 'align-items': 'center'})
  }

  // after ReCharge widget successfully loaded and exist on the page the initial options changer is called
  waitForElement("[class=rc-subscription-details]").then((elm) => {
    availableSubscriptionFrequencies = $('.rc-selling-plans-dropdown__select').find('option');
    let checkedVariant = $("input:radio[checked=checked]")[0].defaultValue;
    onVariantChange(checkedVariant);

    if (isExperimentalRechargeVisible) {
      modifyRcMarkup()
    }
  });

  // iterate the whole options of select and disable options that doesn't met the conditions
  function iterateVariantsSelect(possiblePeriod) {
    $('.rc-selling-plans-dropdown__select').empty() 
    availableSubscriptionFrequencies.each(function(index, value) {
      value.removeAttribute("selected")

      if (possiblePeriod.includes(value.text)) {
        $('.rc-selling-plans-dropdown__select').append(value);
      }
    })
    
    if ($('.rc-selling-plans-dropdown__select').find('option')[0]) {
      setTimeout(() => {
        $('.rc-selling-plans-dropdown__select').find('option')[0].setAttribute("selected", "selected");
      }, 20)
    }

    if (
      $("input:hidden[name=selling_plan]").val(
        $(".rc-selling-plans-dropdown__select").find("option")[0]
      )
    ) {
      $("input:hidden[name=selling_plan]").val(
        $(".rc-selling-plans-dropdown__select").find("option")[0].value
      );
    }
    
  }

  function displayAllVariantsSelect() {
    $('.rc-selling-plans-dropdown__select').empty()
    $('.rc-selling-plans-dropdown__select').append(availableSubscriptionFrequencies);
    $('.rc-selling-plans-dropdown__select').find('option')[0].setAttribute("selected", "selected");
    $("input:hidden[name=selling_plan]").val($('.rc-selling-plans-dropdown__select').find('option')[0].value)
  }

  function changeOptions(variant) {
    // do not work if RechargeWidget does not exist
    if ($("[id^=RechargeWidget]").length === 0) {
      return
    }
    iterateVariantsSelect(variant.metafields.allowed_frequencies.map(i => `Delivery every ${i} Weeks`));
  }

  function changePurchaseType(variant) {
    switch (variant) {
      case true:
        $(".recharge-subscription-widget").show();
        break
      case false:
        $("input:radio[value=onetime]").click();
        $(".rc_widget__option__input--subsave").show();
        $("div[data-option-onetime]").show();
        $(".recharge-subscription-widget").hide();
        break
    }
  }

  function changeSubscriptionPrice(newPrice) {
    // Regex to find the currency price and symbol
    // var match = newPrice.match(/\$([\d.]+)/)
    var match = newPrice.match(/(?:€|\$)(\d+(?:[.,]\d{1,2})?)/)


    if (match) {
      var originalValue = parseFloat(match[1]);
      var reductionPercentage = 5;
      var subscriptionPrice = originalValue * (1 - reductionPercentage / 100);
      var formattedSubscriptionPrice = subscriptionPrice.toFixed(2);
      
      var label = '\n (Regular Price = ' + match[0] + ')'
      // TODO @{lbarrick}: using match[0][0] to get the currency symbol isn't ideal. I think shopify has currency methods that we could use instead.
      var newContent = '<div class="subscription-price-container"><span class="regular-price">SUBSCRIPTION | ' + match[0][0] + formattedSubscriptionPrice + '</span><span class="otp-purchase-price">' + label + '</span></div>' + '</div>';

      $("#subscription-content").children('.rc-radio__label').html(newContent);
      $('.subscription-price-container').css({'display': 'flex', 'flex-direction': 'column'})
      $('.otp-purchase-price').css({'font-size': '14px', 'color': "#989898", 'text-transform': 'none'})
  }
}

  const discountContainer = document.querySelector('.price.price--large.price--highlight.price--subscription-discount');
  const productPrices = this.querySelector("[data-product-price-list]");

  window.onload = function() {
    const oneTimeRadio = document.querySelector('.onetime-radio');
    const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class' && oneTimeRadio.classList.contains("rc-radio--active")) {
          discountContainer.style.display = 'none';
          productPrices.style.textDecoration = "none";
        } else {
          discountContainer.style.display = 'block';
          productPrices.style.textDecoration = 'line-through';

          if (isExperimentalRechargeVisible) {
            modifyRcMarkup()
          }
        }
      }
    });

    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(oneTimeRadio, config);
  };

  // call changeOptions() on each click on variant button
  $(".block-swatch__radio").click(function(event) {
    onVariantChange(event.target.defaultValue)

    // Everytime we click a new variant, we need to update the price. 
    setTimeout(function() {
      originalPrice = $('#onetime-purchase').children('.rc-radio__label').text().trim()
      changeSubscriptionPrice(originalPrice)
    }, 200)
    
  });

  setTimeout(function() {
    $(".subscription-radio").click(function(event) {
      setTimeout(function() {
        changeOptions(productVariants[$(".product-form__option-value").text()]);
      }, 10)
    })
  }, 1000)
});
